import { createStore, type Store } from '@core/store';

import { initialLobby } from './session/lobby';
import type { GameState } from './types';

export type GameStore = Store<GameState>;

export function initialState(): GameState {
  return {
    me: null,
    world: null,
    connection: 'offline',
    confirmed: null,
    seq: 0,
    lastIntentId: 0,
    nextIntentId: 1,
    pending: [],
    view: null,
    planetVersion: 0,
    groups: null,
    predicting: true,
    serverRules: null,
    devTools: false,
    members: new Map(),
    online: new Map(),
    onlineVersion: 0,
    here: -1,
    placing: null,
    overview: false,
    panel: 'none',
    panelTile: -1,
    inset: { bottom: 0, right: 0 },
    away: null,
    lobby: initialLobby(),
  };
}

export const createGameStore = (): GameStore => createStore<GameState>(initialState());
